const footerColumns = [
  {
    title: "圈子分区",
    links: [
      { label: "影视幕后", href: "#circles" },
      { label: "综艺风向", href: "#circles" },
      { label: "游戏圈层", href: "#circles" },
    ],
  },
  {
    title: "标签聚合",
    links: [
      { label: "剪辑争议", href: "#tags" },
      { label: "直播切片", href: "#tags" },
      { label: "配料对比", href: "#tags" },
    ],
  },
  {
    title: "群组与入口",
    links: [
      { label: "群组广场", href: "#groups" },
      { label: "分区导航", href: "#zones" },
      { label: "下载 App", href: "#download" },
    ],
  },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料社区</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              按圈子与话题分区，群组集中讨论，标签快速筛选，热门话题实时更新，让话题脉络更清晰。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-notification-3-line"></i>
              </span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-share-forward-line"></i>
              </span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-customer-service-2-line"></i>
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="whitespace-nowrap text-sm text-background-100/70 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料社区 · 本页为静态展示页面</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>圈子 · 话题 · 标签 · 群组 一体化聚合</span>
            <span>热门话题实时更新</span>
          </p>
        </div>
      </div>
    </footer>
  );
}